/* YNM Boutique — small bits of behaviour. Everything works without it. */
(function () {
  'use strict';

  /* ---- mobile menu ---- */
  var drawer = document.querySelector('[data-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');

  function setMenu(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && closeBtn) closeBtn.focus();
    else if (!open && openBtn) openBtn.focus();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) setMenu(false);
  });

  /* ---- header shadow once you scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- product gallery: thumbnails swap the main image ---- */
  var mainImg = document.getElementById('pdp-main-img');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.dataset.full;
        thumbs.forEach(function (t) { t.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });
  }

  /* ---- product page: price follows the chosen variant ---- */
  var select = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  if (select && priceEl) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var compare = opt.dataset.compare;
      priceEl.innerHTML = (compare ? '<span class="was">' + compare + '</span>' : '') + opt.dataset.price;
    });
  }

  /* ---- countdowns ---- */
  document.querySelectorAll('[data-ynm-countdown]').forEach(function (root) {
    var target = new Date(root.dataset.target).getTime();
    var clock = root.matches('.clock') ? root : root.querySelector('[data-clock]');
    var expired = root.querySelector('[data-expired]');
    var onEnd = root.dataset.onEnd;
    if (isNaN(target)) { if (clock) clock.hidden = true; return; }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function put(sel, val) { var el = root.querySelector(sel); if (el) el.textContent = val; }

    function tick() {
      var left = target - Date.now();
      if (left <= 0) {
        if (clock) clock.hidden = true;
        if (onEnd === 'hide') root.style.display = 'none';
        else if (expired) expired.hidden = false;
        return false;
      }
      var s = Math.floor(left / 1000);
      put('[data-days]', Math.floor(s / 86400));
      put('[data-hours]', pad(Math.floor((s % 86400) / 3600)));
      put('[data-mins]', pad(Math.floor((s % 3600) / 60)));
      put('[data-secs]', pad(s % 60));
      return true;
    }
    if (tick()) setInterval(tick, 1000);
  });
})();
